<script>
import ModalDialog from '../../UI/Modal/ModalDialog.vue'
import FormCreator from '../../UI/Form/FormCreator.vue'
import FieldCreator from '../../UI/Form/FieldCreator.vue'
import ButtonAll from '../../UI/Button/ButtonAll.vue'
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'

export default {
  components: { ButtonAll, FieldCreator, FormCreator, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    simulation: { type: Object, default: {} },
    simulationId: { type: Number, default: '' },
    rent: { type: Object, default: {} },
    def: { type: Object, default: {} },
    isVisible: { type: Boolean, default: false },
  },

  data: () => ({
    noTitle: false,
    sending: false,
    formData: null,
  }),

  watch: {
    isVisible: {
      handler() {
        $('#modal-proposal').modal('show')
      },
    },
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    sendProposal(name) {
      let value = this.$refs.proposalField.datas

      value.finance = {
        duration: this.rent.duration,
      }

      if (name === 'sendProposalClient') {
        if (!value.buyer) {
          alert(this.$root.$t('simulation.popin.proposal.userMissing'))
          return
        }
        value.target = 'client'
      }

      value.equipment = {
        model: value['equipment.model'],
        brand: value['equipment.brand'],
      }

      this.simulation.equipment.model = value.equipment.model
      this.simulation.equipment.brand = value.equipment.brand
      this.patchJSON('quotations/' + this.simulationId + '/proposal', value, {}).then(
        (json) => {
          $('#modal-proposal').modal('hide')
        },
        (reason) => {
          alert(reason)
        },
      )
    },
    isSending(bool) {
      this.sending = bool
    },
  },
}
</script>
<template>
  <ModalDialog
    id="modal-proposal"
    id-modal-page="proposalbox"
    class-modal-dialog="modal-lg"
    title-t="simulation.popin.proposal.title"
    e2e-modal="proposal"
  >
    <template #body>
      <h4 v-if="!noTitle" class="text-center mt-3">{{ $t('simulation.popin.proposal.message') }}</h4>
      <FormCreator
        @update-data="updateData"
        ref="proposalField"
        src-error="proposalField"
        endpoint="quotations"
        method="patch"
        :id="simulation.id"
        :client-id="simulation.client.id"
        :config-def="def"
        :config-object="simulation"
        :dynamic="true"
        :params="{ simulationId: simulationId }"
        class-to-add="d-none"
        @is-sending="isSending"
      ></FormCreator>
      <template v-if="formData !== null">
        <FieldCreator
          :form-data="formData"
          name="equipment.brand"
          form-ref="proposalField"
          domain="simulation"
          :label-top="true"
        ></FieldCreator>
        <FieldCreator
          :form-data="formData"
          name="equipment.model"
          form-ref="proposalField"
          domain="simulation"
          :label-top="true"
        ></FieldCreator>
        <FieldCreator
          :form-data="formData"
          v-if="!hasRole('ROLE_NO_SEND_PROPOSAL')"
          name="buyer"
          :add-user="true"
          form-ref="proposalField"
          domain="simulation"
          :simulation-id="simulationId"
          :label-top="true"
        ></FieldCreator>
        <FieldCreator
          :form-data="formData"
          v-if="!hasRole('ROLE_NO_SEND_PROPOSAL')"
          name="language"
          form-ref="proposalField"
          domain="simulation"
          :label-top="true"
        ></FieldCreator>
      </template>
    </template>
    <!--<div class="text-info text-center" style="font-weight:500;">{{$t('simulation.popin.proposal.explain')}}</div>-->
    <template #footer>
      <ButtonAll margin="no" type="information" data-dismiss="modal" label="button.cancel"></ButtonAll>
      <ButtonAll
        v-if="!hasRole('ROLE_NO_SEND_PROPOSAL')"
        margin="no"
        type="validation"
        @click="sendProposal('sendProposalClient')"
        label="simulation.popin.proposal.sendClient"
      ></ButtonAll>
      <ButtonAll
        margin="no"
        type="validation"
        :loading="sending"
        @click="sendProposal"
        label="simulation.popin.proposal.send"
      ></ButtonAll>
    </template>
  </ModalDialog>
</template>
